import { Card, CardHeader, Divider, useMediaQuery, Box } from '@mui/material';
import type { Theme } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PropertyList } from '../../../../../components/atoms/property-list';
import { PropertyListItem } from '../../../../../components/atoms/property-list-item';
import { Host } from '../../../api/types/host';

interface HostInfoProps {
  host: Host;
}

export const HostInfo: FC<HostInfoProps> = props => {
  const { host, ...other } = props;
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { t } = useTranslation(['host', 'common']);
  const align = mdDown ? 'vertical' : 'horizontal';

  return (
    <Card variant="outlined" {...other}>
      <CardHeader title={t('host:information')} />
      <Divider />
      <Box sx={{ display: 'flex' }}>
        <PropertyList>
          <PropertyListItem align={align} label={t('host:firstName')} value={host.firstName} />
          <PropertyListItem align={align} label={t('host:lastName')} value={host.lastName} />
          <PropertyListItem align={align} label="Email" value={host.email} />
          <PropertyListItem align={align} label={t('host:phoneNumber')} value={host.phoneNumber} />
          <PropertyListItem
            align={align}
            label={t('host:allowedParking')}
            value={host.allowInviteToParking ? t('common:yes') : t('common:no')}
          />
        </PropertyList>
      </Box>
    </Card>
  );
};
